import { inject, Pipe, PipeTransform } from '@angular/core';
import { StorageType } from '@common/models';
import { I18NextPipe } from 'angular-i18next';
import { I18_NAMESPACE_APPS_UI } from 'i18n';

@Pipe({
  name: 'bucketNameText',
  pure: true
})
export class BucketNameTextPipe implements PipeTransform {
  private readonly i18nPipe = inject(I18NextPipe);

  protected readonly moduleAccount = I18_NAMESPACE_APPS_UI.account;

  transform(type: StorageType, mode: 'label' | 'placeholder'): string {
    switch (type) {
      case StorageType.AzureStack:
      case StorageType.Azure:
        return this.i18nPipe.transform(this.moduleAccount + `:sidepanel.${mode}.container`, { format: 'capitalize' });
      default:
        return this.i18nPipe.transform(this.moduleAccount + `:sidepanel.${mode}.bucketName`, { format: 'capitalize' });
    }
  }
}
